export default {"src":"/_next/static/media/tangled-wire.488da8e9.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};